import { createSelector } from 'reselect'

export const selectIn = (selector, key) => {
  return createSelector(
    selector,
    selector => selector && selector.get(key)
  )
}
